import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_FUNCTION} from '../../metamodel/Concept';

export default class TechnologyFunctionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_FUNCTION;
	}
}
